//import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiFetch } from '../../modules/utility.js';
import _ from "lodash";

const apiBase = 'bulkQuotedPrice';
export const search = (p = {}) => {
	const {params = {}, callback = _.noop} = p;
	return dispatch => {
		apiFetch({
			method: `${apiBase}.search`,
			params,
			dispatch,
			callback,
		});
	};
};

const mapStateToProps = (state) => {

	/** @namespace state.lists.bulkQuotedPriceIds */
	/** @namespace state.maps.bulkQuotedPrice */
	let bulkQuotedPrices = [];
	if (state.lists.bulkQuotedPriceIds) {
		bulkQuotedPrices = _.map(state.lists.bulkQuotedPriceIds, id => state.maps.bulkQuotedPrice[id]);
	}

	/** @namespace state.maps.dataDump */
	return {
		bulkQuotedPrices,
		dataDumpMap : state.maps.dataDump,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	searchBulkQuotedPrices : search,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
